import {Injectable} from '@angular/core';
import {ComponentType} from '@angular/cdk/overlay';
import {BehaviorSubject} from 'rxjs';
import {ComponentPortal} from '@angular/cdk/portal';


export interface ComponentsArray {
  component: ComponentPortal<ComponentType<any>>,
  priority: number
}

const components$ = new BehaviorSubject<Array<ComponentsArray>>([]);

@Injectable({
              providedIn: 'root'
            })
export class RightBottomIconService {
  map = new Map<ComponentType<any>, number>();

  constructor() {
  }

  getComponents() {
    return components$;
  }

  registerComponent(priority: number, component: ComponentType<any>) {

    if (!this.map.has(component)) {
      this.map.set(component, priority);
      const current: Array<ComponentsArray> = [];
      this.map.forEach((priority, component) => {

        current.push({component: new ComponentPortal(component), priority});
      });
      components$.next(current);
    }
  }
}
